import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children }) => {
  const { api_token } = useSelector((state) => state.auth); // Get api_token from Redux
  const tokenExpiry = localStorage.getItem("tokenExpiry");

  // Check if api_token exists in Redux OR valid token exists in localStorage
  const isAuthenticated =
    api_token || (tokenExpiry && Date.now() < tokenExpiry);

  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
